/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { BrokenValidationRule } from './BrokenValidationRule'; 

export function validateOrderOptions(orderId: string, onSuccess?: (result: BrokenValidationRule[]) => void) {
	return queryOptions({
		queryKey: ['validate-order', orderId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/orders/queries/validateorder/' + orderId;
			const resp = await axios.get<BrokenValidationRule[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(orderId)
	});
}